import { all, put, takeLatest } from 'redux-saga/effects';
import hanldeException from './../services/handleException';
import { getQuickSearchOrders, getQuickSearchShipment } from './../utils/quickSearch';

function* searchHandle(data) {
    let params = {
        SearchKey: data.payload.key,
        Offset: 10,
        Page: data.payload.page,
    }
    try {
        const json = yield all([getQuickSearchOrders(params), getQuickSearchShipment(params)])
        yield put({ type: 'QUICK_SEARCH_SUCCESS', payload: json, page: data.payload.page })
    } catch (error) {
        hanldeException(error)
        yield put({ type: 'QUICK_SEARCH_FAILURE', error })
    }
}
export function* quickSearchSaga() {
    yield takeLatest('ON_QUICK_SEARCH', searchHandle)
}



// WEBPACK FOOTER //
// ./src/sagas/quicSearchSaga.js